import { useDialog } from '@globals/dialog/useDialogStore'
import { envConfig } from '@globals/env'

const giphyDialogKey = 'giphySearchDialog'
const giphyApiKey = envConfig.GIPHY_API_KEY

const useGiphyDialog = (id: string) => {
  const uniqueDialogKey = `${giphyDialogKey}-${id}`
  const { openDialog, closeDialog } = useDialog(uniqueDialogKey)

  return {
    openGiphyDialog: openDialog,
    closeGiphyDialog: closeDialog,
    giphyDialogKey: uniqueDialogKey,
    giphyApiKey,
  }
}

export default useGiphyDialog
